import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { httpClient } from '@shared/api';
import { env } from '@shared/config/env';

/** V2-4 этап 6: экраны 9/9а — подписчики и «Отправить мне» (бэкенд `cabinet_broadcasts.py`). */

export interface SubsSummary {
  total: number;
  new_7d: number;
  active_30d: number;
  telegram: number;
  max: number;
}

export interface Subscriber {
  id: string;
  name: string;
  platform: 'telegram' | 'max';
  channel_title: string;
  subscribed_at: string;
  messages: number;
  last_at: string | null;
}

export function useSubsSummary(aid: string) {
  return useQuery<SubsSummary, Error>({
    queryKey: ['subscribers', 'summary', aid],
    queryFn: async () =>
      (await httpClient.get<SubsSummary>(`/assistants/${aid}/subscribers/summary`)).data,
    enabled: !!aid,
  });
}

export function useSubscribers(aid: string, q: string, enabled: boolean) {
  return useInfiniteQuery<{ items: Subscriber[]; total: number }, Error>({
    queryKey: ['subscribers', 'list', aid, q],
    queryFn: async ({ pageParam }) =>
      (
        await httpClient.get(`/assistants/${aid}/subscribers`, {
          params: { q: q || undefined, offset: pageParam, limit: 50 },
        })
      ).data,
    initialPageParam: 0,
    getNextPageParam: (last, pages) => {
      const got = pages.reduce((s, p) => s + p.items.length, 0);
      return got < last.total ? got : undefined;
    },
    enabled: !!aid && enabled,
    placeholderData: keepPreviousData,
  });
}

export const broadcastV2Api = {
  async sendTest(aid: string, bid: string, login: string) {
    return (
      await httpClient.post<{ sent_to: string; sent_at: string }>(
        `/assistants/${aid}/broadcasts/${bid}/send-test`,
        { login },
      )
    ).data;
  },
  /** «Проверьте на себе»: код, который владелец пишет своему боту. */
  async testCode(aid: string, bid: string) {
    return (
      await httpClient.post<{ code: string; ttl_sec: number; platform: string }>(
        `/assistants/${aid}/broadcasts/${bid}/test-code`,
      )
    ).data;
  },
  async testCodeStatus(aid: string, bid: string, code: string) {
    return (
      await httpClient.get<{
        found: boolean;
        external_id: string | null;
        name: string | null;
        sent: boolean;
        error: string | null;
      }>(`/assistants/${aid}/broadcasts/${bid}/test-code/${code}`)
    ).data;
  },
  async changeChannel(aid: string, bid: string, channelId: string) {
    return (
      await httpClient.post(`/assistants/${aid}/broadcasts/${bid}/channel`, {
        channel_id: channelId,
      })
    ).data;
  },
};

/** Ссылка на медиа рассылки для превью (тот же прокси, что берёт Telegram). */
export function broadcastMediaUrl(bid: string, s3Key: string) {
  return `${env.API_BASE_URL.replace(/\/$/, '')}/broadcast-media/${bid}/raw?key=${encodeURIComponent(s3Key)}`;
}
